import { TransferOrderImportPage } from "@/features/transfer-order/pages/TransferOrderImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-order/import")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["transfer_order.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: TransferOrderImportPage,
});
